import React from "react";
import { NavLink } from "react-router-dom";

export default () => {
  return (
    <aside className="drawer-side z-10">
      <label htmlFor="my-drawer" className="drawer-overlay"></label>
      <nav className="flex min-h-screen w-72 flex-col gap-2 overflow-y-auto bg-base-100 px-6 py-10">
        <div className="mx-4 flex items-center gap-2 font-black">
          <svg
            width="32"
            height="32"
            viewBox="0 0 1024 1024"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="256"
              y="670.72"
              width="512"
              height="256"
              rx="128"
              className="fill-base-content"
            />
            <circle
              cx="512"
              cy="353.28"
              r="256"
              className="fill-base-content"
            />
            <circle
              cx="512"
              cy="353.28"
              r="261"
              stroke="black"
              strokeOpacity="0.2"
              strokeWidth="10"
            />
            <circle
              cx="512"
              cy="353.28"
              r="114.688"
              className="fill-base-100"
            />
          </svg>
        </div>
        <ul className="menu">
          <li>
            <NavLink to="/">
              {" "}
              <svg
                data-src="https://unpkg.com/heroicons/20/solid/home.svg"
                className="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                data-slot="icon"
                data-id="svg-loader_4"
              >
                <path
                  fill-rule="evenodd"
                  d="M9.293 2.293a1 1 0 0 1 1.414 0l7 7A1 1 0 0 1 17 11h-1v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6H3a1 1 0 0 1-.707-1.707l7-7Z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink to="/realtime">
              <svg
                data-src="https://unpkg.com/heroicons/20/solid/squares-2x2.svg"
                className="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                data-slot="icon"
                data-id="svg-loader_13"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.25 2A2.25 2.25 0 0 0 2 4.25v2.5A2.25 2.25 0 0 0 4.25 9h2.5A2.25 2.25 0 0 0 9 6.75v-2.5A2.25 2.25 0 0 0 6.75 2h-2.5Zm0 9A2.25 2.25 0 0 0 2 13.25v2.5A2.25 2.25 0 0 0 4.25 18h2.5A2.25 2.25 0 0 0 9 15.75v-2.5A2.25 2.25 0 0 0 6.75 11h-2.5Zm9-9A2.25 2.25 0 0 0 11 4.25v2.5A2.25 2.25 0 0 0 13.25 9h2.5A2.25 2.25 0 0 0 18 6.75v-2.5A2.25 2.25 0 0 0 15.75 2h-2.5Zm0 9A2.25 2.25 0 0 0 11 13.25v2.5A2.25 2.25 0 0 0 13.25 18h2.5A2.25 2.25 0 0 0 18 15.75v-2.5A2.25 2.25 0 0 0 15.75 11h-2.5Z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              Realtime
            </NavLink>
          </li>
          <li>
            <NavLink to="/valets">
              <svg
                data-src="https://unpkg.com/heroicons/20/solid/user.svg"
                className="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                data-slot="icon"
                data-id="svg-loader_11"
              >
                <path d="M10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.465 14.493a1.23 1.23 0 0 0 .41 1.412A9.957 9.957 0 0 0 10 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 0 0-13.074.003Z"></path>
              </svg>
              Valets
            </NavLink>
          </li>
          <li>
            <NavLink to="/venues">
              <svg
                data-src="https://unpkg.com/heroicons/20/solid/squares-2x2.svg"
                className="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                data-slot="icon"
                data-id="svg-loader_13"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.25 2A2.25 2.25 0 0 0 2 4.25v2.5A2.25 2.25 0 0 0 4.25 9h2.5A2.25 2.25 0 0 0 9 6.75v-2.5A2.25 2.25 0 0 0 6.75 2h-2.5Zm0 9A2.25 2.25 0 0 0 2 13.25v2.5A2.25 2.25 0 0 0 4.25 18h2.5A2.25 2.25 0 0 0 9 15.75v-2.5A2.25 2.25 0 0 0 6.75 11h-2.5Zm9-9A2.25 2.25 0 0 0 11 4.25v2.5A2.25 2.25 0 0 0 13.25 9h2.5A2.25 2.25 0 0 0 18 6.75v-2.5A2.25 2.25 0 0 0 15.75 2h-2.5Zm0 9A2.25 2.25 0 0 0 11 13.25v2.5A2.25 2.25 0 0 0 13.25 18h2.5A2.25 2.25 0 0 0 18 15.75v-2.5A2.25 2.25 0 0 0 15.75 11h-2.5Z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              Venues
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
};
